module.exports = __webpack_public_path__ + "img/calendar-empty-list-dark.52fb3b23.svg";